import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

// Import all page components
import GpaCalculator from './components/GpaCalculator';
import Navbar from './components/Navbar';
import FacultyListPage from './components/FacultyListPage';
import FacultyDetailPage from './components/FacultyDetailPage';
import TimetableMaker from './components/TimetableMaker';
import AddFacultyPage from './components/AddFacultyPage';
import LostFoundPage from './components/LostFoundPage';
import FacultyCabinFinder from './components/FacultyCabinFinder';
import WhatsAppGroupsPage from './components/WhatsAppGroupsPage'; // Import Cabin Finder
import FeedbackPage from './components/FeedbackPage';

// Import main CSS
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* --- Site Header --- */}
        <header className="site-header">
          <Link to="/" className="site-logo">
            {/* Your updated logo text */}
            <span className="logo-main">SUB</span>
            <span className="logo-campus">(Student Utility Base)</span>
          </Link>
          <Navbar />
        </header>

        {/* --- Main Content Area --- */}
        <main className="main-content">
          <Routes>
            {/* GPA Calculator Route (Home) */}
            <Route path="/" element={<GpaCalculator />} />

            {/* Faculty Review Routes */}
            <Route path="/faculty" element={<FacultyListPage />} />
            <Route path="/faculty/:id" element={<FacultyDetailPage />} />
            <Route path="/add-faculty" element={<AddFacultyPage />} />

            {/* Timetable Maker Route */}
            <Route path="/timetable" element={<TimetableMaker />} />

            {/* Lost & Found Route */}
            <Route path="/lostfound" element={<LostFoundPage />} />

            {/* Faculty Cabin Finder Route */}
            <Route path="/cabin-finder" element={<FacultyCabinFinder />} />

            {/* Whatsapp group link Route */}
            <Route path="/whatsapp-groups" element={<WhatsAppGroupsPage />} /> 

            <Route path="/feedback" element={<FeedbackPage />} /> {/* Feedback Route*/}

          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;